module.exports = require(40).Transform
